import {PopoverElement} from '../../../classes/popover-element';
import {LeafletEagleiSource} from '../../../modules/layer/classes/leaflet-eaglei-source';
import {GenEventResultItem} from '../../../../../generated/serverModels/GenEventResultItem';
import {GenHeadoutEvent} from '../../../../../generated/serverModels/GenHeadoutEvent';
import {HeadoutEventResultItem} from '../classes/headout-event-result-item';
import {SystemEvent} from '../../../modules/system-event/classes/system-event';

export const baseCustomerPopover: (detail: GenEventResultItem) => PopoverElement[] = (detail: HeadoutEventResultItem) => {
    return [
        new PopoverElement('title', `${detail.stateName} - ${detail.countyName}`).setTitle(),
        new PopoverElement('Predicted Customers Out', `${LeafletEagleiSource.numberPipe.transform(detail.customers)}`),
        new PopoverElement('Predicted Percent Out', `${LeafletEagleiSource.percentPipe.transform(detail.percent, '1.2-2')}`),
        new PopoverElement('Total Customers', `${LeafletEagleiSource.numberPipe.transform(detail.totalcustomers)}`),
    ];
};

export const getCustomerDetailPopover = (outageInfo: GenEventResultItem, advisoryId: string, event: SystemEvent) => {
    const baseFields = baseCustomerPopover(outageInfo);
    switch (event.type.name.toLowerCase()) {
        case 'hurricane':
            return [...baseFields, new PopoverElement('Hurricane', event.name), new PopoverElement('NHC Advisory', advisoryId)];
        default:
            return baseFields;
    }
};
